import Vue from 'vue';


function getDays(seconds: number): number {
  return getHours(seconds) / 24;
}

function getHours(seconds: number): number {
  return getMinutes(seconds) / 60;
}

function getMinutes(seconds: number): number {
  return seconds / 60;
}

function getSeconds(seconds: number): number {
  return seconds;
}

// usage: ${file.size | prettyBytes}
Vue.filter('prettyDuration', (duration: number) => {
  if (isNaN(duration)) {
    throw new TypeError('Expected a number');
  }

  const days = Math.floor(getDays(duration));
  const hours = Math.floor(getHours(duration) % 24);
  const minutes = Math.floor(getMinutes(duration) % 60);
  const seconds = Math.floor(getSeconds(duration) % 60);

  return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
});


